export const content = [
    {
        id: 1,
        text:
            '<p>How it works:</p>' +
            '<ul>' +
            '<li>When your subscription ends, we\'ll transfer ownership to you for the price of S$1.00</li>' +
            '<li>No action required on your part - seamless and convenient</li>' +
            '</ul>'
    }
];
